import React from "react";
import { render } from "react-dom";
import * as Sentry from "@sentry/react";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./utils/i18n";
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";

Sentry.init({ dsn: process.env.REACT_APP_SENTRY_URI });

const client = new ApolloClient({
  uri: `${process.env.REACT_APP_GRAPHQL_ENDPOINT}`,
  cache: new InMemoryCache()
});

const rootElement = document.getElementById("root");

render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
